<script setup>
import { deviceStore } from './../stores/deviceStore'
import  ViewPorts  from './viewPort.vue'
import  SmartMeetingComponent  from './SmartMeetingComponent.vue'
import RootMenu from './SimpliaV2Components/RootMenu/RootMenu.vue';
import  Alert from './Alert.vue'
import * as oxygenUtil from './SimpliaV2Components/OxygenUtil/oxygenutil.js';

console.log("Got a store in viewport component",window.top.botStore.settings.SmartView);
const store = deviceStore();
const botStore = window.top.botStore;

</script>

<script>
export default {
  components: {
      ViewPorts,
      RootMenu,
      Alert
 },
  data: () => ({
    context : [],
  }),
  mounted() {
    window.showRootMenu = () => {
      this.$refs.rootMenu.showMenu();
    }
    this.setEventHandlers();
  },
  methods : {
    setEventHandlers() {
      this.setUserAuthenticatedEventHandler();
    },
    setUserAuthenticatedEventHandler() {

      window.addEventListener("userAuthenticated", (event) => {

        let intervalId = setInterval(async ()=>{

          if(window.devStore.clients.length > 1) {
            clearInterval(intervalId);
            let client = window.devStore.clients[window.devStore.clients.length - 1];

            if(client.Attribution) {
              let bookmark = await oxygenUtil.getAttributionBookmarks(client.Attribution, 'Homepage');

              let json;
              if(bookmark && (json = oxygenUtil.tryParseJSON(bookmark.ArgJSON))) {
                let type = {
                  'Parent': this.openParentBookmark.bind(this),
                  'Child': this.openChildBookmark.bind(this)
                }

                if(json.Type && type[json.Type]) {
                  type[json.Type](json, client);
                }
              }
            }
          }
        },100);
      });
    },
    openParentBookmark(args, client) {

      window.BotServices.PullPE(
          {
            ByClientID : client.Client,
            InitialContext : {
              ByClientID : client.Client
            },
            OpenPE : args.MeetingContext.ContextPE
          }
      );
    },
    openChildBookmark(args, client) {
      let PE = oxygenUtil.createSimpleOES([args.LeftRole, args.LeftID, args.RightRole, args.RightID]);

      let numCurrentClients = window.devStore.clients.length;
      window.BotServices.PullPE(
          {
            ByClientID : client.Client,
            InitialContext : {
              ByClientID : client.Client
            },
            OpenPE : PE
          },
          (error)=>{
            if(!error) {
              let intervalId = setInterval(()=>{
                if(numCurrentClients < window.devStore.clients.length) {
                  clearInterval(intervalId);
                  let newClient = window.devStore.clients.reverse().find((e) => {

                    let json = oxygenUtil.tryParseJSON(e.MeetingContext);

                    return json.ContextPE === PE;
                  });

                  if(newClient) {
                    let parsedPath = args.Path.split("/");
                    window.BotServices.openChildPanel({ClientID: newClient.Client, DisplayName:parsedPath[parsedPath.length - 1],
                      Termination: args.Termination });
                  }
                }

              }, 100);
            }
          }
      );
    },
    initClient : function (client) {
      console.log("Init Client Got ", client);
      this.context.push(client);
    },
    openAlert : function (alertObj) {
      this.$refs.alert.showAlert(alertObj);
    },
    hideAlert : function(data) {
        this.$refs.alert.hideAlert(data);
    },
    setMeeting :  function() {
      window.DevMgr.setMeeting(document.getElementById('meetingName').value);
      var modal = document.getElementById("saveMeeting");
      modal.style.display = "none";
    }
  }
}

</script>

<template>
<div v-if="botStore.settings.SmartView == 'true'">
   <SmartMeetingComponent></SmartMeetingComponent>
  
</div>
<div v-else>
  <ViewPorts></ViewPorts>
  <root-menu ref="rootMenu"/>
  <Alert ref="alert"></Alert>
</div>

</template>


<style scoped>

</style>
